import "./flipbook_modal.scss";

require('../../lib/dflip/css/dflip.css');
require('../../lib/dflip/css/themify-icons.css');

var modalDom = require('./modal.html');
var modalButtonHoverDom = require('./flipbook_modal_button_hover.html');
var dflipLoaded = false;

var legacyDom = require('./no3D.html');


var insertDflipScriptAndSetup = (callbackFunction) => {
  var insertedDflip = $( "script#dflip" );
  if (insertedDflip.length > 0)
  {
    if (dflipLoaded) {
      callbackFunction();
    }
    else
    {
      insertedDflip.on('load', () => {
        callbackFunction();
      });
    }
    return;
  }

  var scriptDom = document.createElement('script');
  $( scriptDom ).attr('id', 'dflip')
  scriptDom.src = "/dflip/js/dflip.js";
  scriptDom.type = "text/javascript";
  $( scriptDom ).on('load', () => {
    dflipLoaded = true;
    callbackFunction();
  });
  document.head.appendChild(scriptDom);
};

class FlipBookBuilder {
  constructor(target, sourceUrl, flipBookOptions) {
    $ = window.$;
    this.target = target;
    this.pdfUrl = sourceUrl;
    this.options = $.extend({
      height: '100%', soundEnable: false, overwritePDFOutline: true, backgroundColor: 'transparent', scrollWheel: false
    }, flipBookOptions);
    console.log(this.options);
  }

  setup() {
    if ($('body').data('visio-enabled')) {
      var legacy = $(legacyDom);
      legacy.attr('data', `${this.pdfUrl}#toolbar=0`);

      $(this.target).replaceWith(legacy);
    } else {
      insertDflipScriptAndSetup(()   => {
        var flipBook = $(this.target).flipBook( this.pdfUrl, this.options );
      });
    }
  }
}

class FlipBookModalBuilder {
  constructor(targetButton, sourceUrl, flipBookOptions) {
    this.targetButton = targetButton;
    this.pdfUrl = sourceUrl;
    this.options = $.extend({
      height: '100%', soundEnable: false, overwritePDFOutline: true, backgroundColor: 'transparent', scrollWheel: false
    }, flipBookOptions);
  }

  setup() {
    if (this.targetButton.prop('tagName') === 'A')
    {
      var hoverDom = $( modalButtonHoverDom );
      this.targetButton.append(hoverDom);
    }

    this.targetButton.on('click', (e) => {
      e.preventDefault();
      var dom = $( modalDom );

      $( 'body' ).append(dom);
      dom.on('show.bs.modal', (e) => {
        var flipbookTarget = dom.find('.flipbookContainer');
        this.flipBookBuilder = new FlipBookBuilder(flipbookTarget, this.pdfUrl, this.options);
        this.flipBookBuilder.setup();
      });

      dom.modal('show');

      return e;
    });
  }
}

$( document ).ready(() => {
  $( ".flipbook-container" ).each((i, e) => {
    var options = $( e ).data('flipbook-options');
    var builder = new FlipBookBuilder($( e ), $( e ).data('flipbook-src'), options);
    builder.setup();
  });

  $( ".flipbook-modal-button" ).each((i, e) => {
    var options = $( e ).data('flipbook-options');
    var modalBuilder = new FlipBookModalBuilder($( e ), $( e ).data('flipbook-src'), options);
    modalBuilder.setup();
  });
});

var buildFlipbook = function (options) {
  var settings = $.extend({
  }, options );
  var builder = new FlipBookBuilder($(this), settings.sourceUrl, settings.options);
  builder.setup();

  return builder;
};

export default buildFlipbook;
